import { createRpcBackend } from "@/backend/backendProvider";

export class SessionsHandler {
  constructor(context) {
    this.backend = createRpcBackend(context);
  }

  getSession(id) {
    return this.backend.rootCall("get_session", [id]);
  }

  getSessions() {
    return this.backend.rootCall("get_sessions", []);
  }

  createTemplateSession(type) {
    return this.backend.rootCall("create_template_session", [type]);
  }

  getTemplateSessions() {
    return this.backend.rootCall("get_available_template_sessions", []);
  }

  getUsersSeeAllSessions() {
    return this.backend.rootCall("get_users_see_all_sessions");
  }

  setUsersSeeAllSessions(value) {
    return this.backend.rootCall("set_users_see_all_sessions", [value]);
  }
}
